/* Poseidon (R12): fills "Pairs well with your search" (sections/pzs-search-recs) once the page has loaded, so the
   results themselves are never held up.
   Sources, for the top 1 or 2 product results:
     complementary  Shopify recommendations, intent=complementary (set in Search & Discovery; empty until then)
     pairs          what the product page "Pairs with" logic picks (pair groups, then the type map), from the page
     related        Shopify recommendations, intent=related
     popular        Popular parts, only to top up a short row
   A product found by several sources adds their weights, so a related product that the Pairs with logic also
   picked rises above one it did not. Products already in the results are dropped, coming soon ones sink. */
(function () {
  'use strict';
  var sec = document.querySelector('[data-pz-recs]');
  if (!sec || sec.__pzRecs) return;
  sec.__pzRecs = true;
  var rail = sec.querySelector('[data-pz-recs-rail]');
  if (!rail) return;
  var excl = {};
  (sec.getAttribute('data-exclude') || '').split(',').forEach(function (x) { if (x) excl[x] = 1; });
  var top = (sec.getAttribute('data-top') || '').split(',').filter(Boolean).slice(0, 2);
  var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
  var url = sec.getAttribute('data-url') || '/recommendations/products';
  var sid = sec.getAttribute('data-section-id');
  var WEIGHT = { complementary: 100, pairs: 60, related: 30, popular: 4 };
  var pool = {}, n = 0;

  function add(root, src, owner) {
    if (!root) return;
    var lis = root.querySelectorAll('li[data-product-id]');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i], id = li.getAttribute('data-product-id');
      if (!id || excl[id]) continue;
      var s = WEIGHT[src] - i * 0.5 - (owner || 0) * 6;
      if (li.hasAttribute('data-soon')) s -= 45;
      if (li.hasAttribute('data-out')) s -= 60;
      var c = pool[id];
      if (c) { if (!c.src[src]) { c.score += s; c.src[src] = 1; } }
      else { var o = {}; o[src] = 1; pool[id] = { li: li, score: s, src: o, at: n++ }; }
    }
  }
  function parse(html) { var t = document.createElement('template'); t.innerHTML = html; return t.content; }
  function tpl(name) { var t = sec.querySelector('template[data-pz-recs-src="' + name + '"]'); return t ? t.content : null; }
  function ranked() {
    return Object.keys(pool).map(function (k) { return pool[k]; })
      .sort(function (a, b) { return (b.score - a.score) || (a.at - b.at); });
  }

  function arrows() {
    var pv = sec.querySelector('[data-pz-recs-prev]'), nx = sec.querySelector('[data-pz-recs-next]');
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var step = function () { var c = rail.children[0]; return c ? (c.offsetWidth + (parseFloat(getComputedStyle(rail).columnGap) || 12)) * 2 : 400; };
    var state = function () {
      var m = rail.scrollWidth - rail.clientWidth;
      if (pv) pv.disabled = rail.scrollLeft < 4;
      if (nx) nx.disabled = rail.scrollLeft > m - 4;
      sec.classList.toggle('pz-rail-static', m < 4);
    };
    if (pv) pv.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    var t; rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(state, 60); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(state, 120); });
    state();
  }

  function show(list) {
    var frag = document.createDocumentFragment();
    list.forEach(function (c) { frag.appendChild(document.importNode(c.li, true)); });
    rail.appendChild(frag);
    sec.hidden = false;
    arrows();
  }

  function run() {
    var jobs = [];
    top.forEach(function (id, owner) {
      ['complementary', 'related'].forEach(function (intent) {
        jobs.push(
          fetch(url + '?product_id=' + encodeURIComponent(id) + '&limit=6&intent=' + intent + '&section_id=' + encodeURIComponent(sid))
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; })
            .then(function (h) { return { h: h, intent: intent, owner: owner }; })
        );
      });
    });
    Promise.all(jobs).then(function (res) {
      res.filter(function (x) { return x.intent === 'complementary'; }).forEach(function (x) { if (x.h) add(parse(x.h), 'complementary', x.owner); });
      add(tpl('pairs'), 'pairs');
      res.filter(function (x) { return x.intent === 'related'; }).forEach(function (x) { if (x.h) add(parse(x.h), 'related', x.owner); });
      var list = ranked();
      if (list.length < 4) { add(tpl('popular'), 'popular'); list = ranked(); }
      list = list.slice(0, limit);
      if (list.length >= 3) show(list);
    });
  }

  function later(fn) {
    var go = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 1200 }) : setTimeout(fn, 200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  if (top.length) later(run);
})();
